import React, { useEffect, useRef, useState } from 'react';
import {  useLocation, useParams } from 'react-router-dom';
import { FaBirthdayCake, FaGlassCheers, FaHome, FaLeaf, FaRegGrinStars, FaSun } from 'react-icons/fa';
import { BsFillGiftFill } from 'react-icons/bs';

import { FilteredItemList } from './Detail/ServiceIcons/FilteredItemList';
import { GaleryFirst } from './Images/GaleryFirst';
import { PromotionSections } from './Detail/Promociones/Promotions/PromotionSections';
import { Confirmacion } from './Detail/Confirmacion';

import MenuWithSections from './Detail/Menu/MenuWithSections';
import MapComponent from '../../shared/MapComponent';
import FiestaSpinner from '../../shared/FiestaSpinner';
import './lugar.css';

import { API_BASE_URL } from '../../../config/config.js'; 
import ErrorPage from '../../shared/ErrorPage.js';
import { GiBalloons, GiMale, GiPartyPopper, GiTicket } from 'react-icons/gi';
import { FaFire, FaRegFaceGrinSquint } from 'react-icons/fa6';
import { MdCelebration } from 'react-icons/md';
import VideoComponent from './Images/VideoComponent.js';

// Función para obtener el ícono según el tipo de lugar
const getIconByType = (type) => {
  switch (type) {
    case 'jardin':
      return <FaLeaf className="icon-jardin" />;
    case 'infantil':
      return <BsFillGiftFill className="icon-infantil" />;
    case 'salon':
      return <FaGlassCheers className="icon-salon" />;
    case 'hacienda':
      return <FaHome className="icon-hacienda" />;
    case 'terraza':
      return <FaSun className="icon-terraza" />;
    default:
      return null; // Retorna null si el tipo no coincide
  }
};

// Componente principal que muestra los detalles de un lugar específico
export const DetalleLugar = () => {
  const { itemType } = useParams();
  const location = useLocation();
  const { selectedId, imagePrincipal } = location.state || {};

  const { name: nameFromUrl, id: idFromUrl } = useParams();

  console.log("selectedId from URL:", idFromUrl);
  console.log("name from URL:", nameFromUrl);


  const [itemDetails, setItemDetails] = useState(null); // /**Todo el objeto */
  const [generalData, setGeneralData] = useState(null); // Información general del salón
  const [images, setImages] = useState({ mainImage: imagePrincipal, others: [] }); //estado para guardar imagenes
  const [eventos, setEventos] = useState([]); //Estado para eventos
  const [amenidades, setAmenidades] = useState([]); //Estado para amenidades
  const [adicionales, setAdicionales] = useState([]); // Servicios adicionales
  const [isError, setIsError] = useState(false);
  const [video, setVideo] = useState([]);

  // Datos específicos de paquetes y menú
  const [paquetes, setPaquetes] = useState([]); // Paquetes generales
  const [nombrePaquetes, setNombrePaquetes] = useState([])

  // Ref para el sticky header
  const stickyHeaderRef = useRef(null);

  // Estado para la sección activa
  const [activeSection, setActiveSection] = useState('');

  const selectedIdToUse = selectedId || idFromUrl; // Usamos selectedId si está en el estado, si no lo obtenemos de la URL

  console.log('selectedId:', selectedIdToUse);
  useEffect(() => {
    window.scrollTo(0, 0);

    if (!selectedIdToUse) {
      console.warn('No se proporcionó selectedId');
      setIsError(true); 
      return;
    }
  
    // Función para obtener los datos con expiración
    const getDataWithExpiry = (key) => {
      const storedData = localStorage.getItem(key);
      if (!storedData) return null;
  
      const { value, expiresAt } = JSON.parse(storedData);
      const now = new Date();
  
      if (new Date(expiresAt) < now) {
        // Si los datos han expirado, los eliminamos
        localStorage.removeItem(key);
        return null;
      }
  
      return value;
    };
  
    // Función para almacenar los datos con fecha de expiración
    const storeDataWithExpiry = (key, value) => {
      const now = new Date();
      //const expiryTime = new Date(now.getTime() + 1 * 60 * 1000); // 1 minuto desde ahora
      const expiryTime = new Date(now.getTime() + 12 * 60 * 60 * 1000); // 24 horas desde ahora
      const dataWithExpiry = {
        value,
        expiresAt: expiryTime,
      };
      localStorage.setItem(key, JSON.stringify(dataWithExpiry));
    };
  
    // Función para limpiar peticiones antiguas si hay más de 30
    const cleanOldRequests = () => {
      const maxStoredRequests = 30;
      const keys = Object.keys(localStorage);
      const placeKeys = keys.filter(key => key.startsWith('placeDetails-'));
  
      if (placeKeys.length >= maxStoredRequests) {
        const sortedKeys = placeKeys.sort((a, b) => {
          const dataA = JSON.parse(localStorage.getItem(a));
          const dataB = JSON.parse(localStorage.getItem(b));
          return new Date(dataA.expiresAt) - new Date(dataB.expiresAt);
        });
  
        localStorage.removeItem(sortedKeys[0]); // Eliminar el más antiguo
      }
    };
  
    // Llamar a cleanOldRequests para asegurarnos de no almacenar más de 30 peticiones
    cleanOldRequests();
  
    // Verificamos si los datos ya están en el localStorage
    const storedData = getDataWithExpiry(`placeDetails-${selectedIdToUse}`);
    
    if (storedData) {
      // Si los datos están en cache y no han expirado, los usamos
      console.log('Datos del localStorage:', storedData);
      setItemDetails(storedData.itemDetails);
      setGeneralData(storedData.generalData);
      setImages(storedData.images);
      setVideo(storedData.video)
      setEventos(storedData.eventos);
      setAmenidades(storedData.amenidades);
      setAdicionales(storedData.adicionales);
      setPaquetes(storedData.paquetes);
      setNombrePaquetes(storedData.nombrePaquetes);
    } else {
      // Si no están en cache o han expirado, realizar la petición
      const fetchItemDetails = async () => {
        try {
          const response = await fetch(`${API_BASE_URL}/lugares/${selectedIdToUse}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          });
  
          if (!response.ok) {
            throw new Error(`Error al obtener los datos: ${response.statusText}`);
          }
  
          const contentType = response.headers.get('Content-Type');
  
          if (contentType && contentType.includes('application/json')) {
            const data = await response.json();
  
            // Medir el tamaño de la respuesta en bytes
            const sizeInBytes = new TextEncoder().encode(JSON.stringify(data)).length;
            console.log(`Tamaño de la respuesta: ${sizeInBytes} bytes`);
  
            // Guardamos los datos en el estado
            setItemDetails(data);
            setGeneralData({
              id: data.id,
              name: data.name,
              phone: data.phone,
              lat: data.latitud,
              long: data.longitud,
              description: data.description,
              address: data.address,
              hours: data.hours,
              eventHours: data.eventHours,
              priceInitial: data.priceInitial,
              priceFinal: data.priceFinal,
              capacityInitial: data.capacityInitial,
              capacityMax: data.capacityMax,
              tipoLugar: data.tipoLugar,
            });
            
            const sortedImages = [...data.images]
            .sort((a, b) => a.prioridad - b.prioridad);


             // Filtrar las imágenes con prioridad cero
            const priorityZeroImages = sortedImages.filter(image => image.prioridad === 0);
            const urls = priorityZeroImages.map(item => item.url); // Extraemos las URLs
            
            const imagenprincipal=sortedImages.filter(image => image.prioridad === 1);
          
            const othersImages = sortedImages.filter(image => image.prioridad !== 1 && image.prioridad !== 0);
            
            console.log("Estas soes el arreglo",othersImages, imagenprincipal)
          
            const newImages = {
              mainImage: imagenprincipal,
              others: othersImages,
            };        
  
            setImages(newImages);
            setVideo(urls);
            setEventos(data.tiposEvento || []);
            setAmenidades(data.amenidades || []);
            setAdicionales(data.serviciosAdicionales || []);
  
            const formattedPaquetes = data.paquetes.map((section) => {
              return {
                id: section.id,
                nombre: section.nombre,
                descripcion: section.descripcion,
                
                // 🔹 Extraer promociones globales (de la raíz del JSON)
                promocionesGlobales: data.promociones || [],
                // 🔹 Extraer tarifas
                
                tarifas: section.tarifas?.map((tarifa) => ({
                  cantidadMinima: tarifa.cantidadMinima,
                  cantidadMaxima: tarifa.cantidadMaxima,
                  costoPorPersona: tarifa.costoPorPersona,
                })) || [],
                serviciosIncluidos: section.serviciosIncluidos|| [],
                serviciosComida: section.serviciosComida|| [],
                serviciosRecomendados: section.serviciosRecomendados|| [],
                promocionesPaquete: section.promociones || [],

                   // 🔹 Extraer comidas, bebidas y complementos
              comidas: section.comidas?.map((comida) => ({
                tipoMenu: comida.nombre, // Nombre del menú
                tiempos: comida.tiempos?.map((tiempo) => ({
                  tiempoMenu: tiempo.nombre,
                  platillos: tiempo.opcionesPlatillo || [], // Lista de platillos
                })) || [],
                bebidas: comida.bebidas || [],
                complementos: comida.complementos || [],
              })) || [],
              };
            });
             
            console.log("📢 Paquetes transformados:", formattedPaquetes);
      
            setPaquetes(formattedPaquetes);
           
            const nombres = formattedPaquetes.map((paquete) => ({
              id: paquete.id,
              nombre: paquete.nombre
            }));
            setNombrePaquetes(nombres);
  
            // Guardamos los datos en el localStorage con fecha de expiración
            storeDataWithExpiry(`placeDetails-${selectedIdToUse}`, {
              itemDetails: data,
              generalData: {
                id: data.id,
                name: data.name,
                phone: data.phone,
                lat: data.latitud,
                long: data.longitud,
                description: data.description,
                address: data.address,
                hours: data.hours,
                eventHours: data.eventHours,
                priceInitial: data.priceInitial,
                priceFinal: data.priceFinal,
                capacityInitial: data.capacityInitial,
                capacityMax: data.capacityMax,
                tipoLugar: data.tipoLugar,
              },
              images: newImages,
              video:urls,
              eventos: data.tiposEvento || [],
              amenidades: data.amenidades || [],
              adicionales: data.serviciosAdicionales || [],
              paquetes: formattedPaquetes,
              nombrePaquetes: nombres,
            });
  
          } else {
            const textResponse = await response.text();
            console.error('Respuesta no JSON:', textResponse);
            throw new Error('La respuesta no es JSON');
          }
        } catch (error) {
          console.error('Error al obtener los datos:', error);
        }
      };
  
      fetchItemDetails();
    }
  }, [selectedIdToUse]);
  
  useEffect(() => {
    console.log("este es el estado de images", images)
    // Define las secciones y los umbrales
    const sections = ['eventos', 'amenidades', 'paquetes', 'menu', 'adicionales'];
    const thresholds = {
      eventos: 0.8,
      amenidades: 0.7,
      paquetes: 0.5,
      menu: 0.5,
      adicionales: 1
    };
  
    // Crear y almacenar observadores
    const observers = {};
  
    const updateObservers = () => {
      // Primero, desconectar todos los observadores existentes
      sections.forEach(sectionId => {
        if (observers[sectionId]) {
          observers[sectionId].disconnect();
        }
      });
  
      // Crear un nuevo observador para cada sección
      sections.forEach(sectionId => {
        const threshold = thresholds[sectionId] || 0.0; // Asegúrate de obtener el umbral para cada sección
  
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              setActiveSection(entry.target.id);
            }
          });
        }, {
          threshold: threshold // Usar el umbral aquí
        });
  
        observers[sectionId] = observer;
        const section = document.getElementById(sectionId);
        if (section) {
          observer.observe(section);
        }
      });
    };
  
    // Configurar los observadores inicialmente
    updateObservers();
  
    // Actualizar observadores cuando cambien las secciones
    return () => {
      // Desconectar todos los observadores al desmontar
      sections.forEach(sectionId => {
        if (observers[sectionId]) {
          observers[sectionId].disconnect();
        }
      });
    };
  }, [itemDetails]); // Dependencia en itemDetails para actualizar observadores cuando cambie el contenido
  

  const scrollToSection = (sectionId) => {
    const headerHeight = stickyHeaderRef.current?.offsetHeight || 0;
    const element = document.getElementById(sectionId);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - headerHeight,
        behavior: 'smooth',
      });
    }
  };  

  if (isError) {
    return <ErrorPage />;
  }

  if (!itemDetails) {
    return (
      <div className="centered-spinner">
        <FiestaSpinner />
      </div>
    );
  }

  const { id, phone, capacityInitial, capacityMax, lat,long} = generalData;
  const TipoPaquete = paquetes.map((section) => {
    const cantidadMinima = section.tarifas?.[0]?.cantidadMinima ?? 0;
  
    return cantidadMinima === 0 ? "sin paquete" : "con paquete";
  });
  

  return (
    <div className="master-container contents">
      <h1 className='title'>{getIconByType(itemType)} {generalData.name}</h1>
      <GaleryFirst
        imagePrincipal={images.mainImage}
        otherImages={images.others}
        videos={video}
      />

      <div className="welcome-section">
        <h2 className='welcome'>¡Bienvenidos!</h2>
        <p>En <strong>{generalData.name}</strong>, te ofrecemos un espacio único para tus eventos.</p>
        <p>Conoce todo lo que podemos ofrecerte para hacer de tu celebración un momento inolvidable.</p>
      </div>

      <header className="sticky-header" ref={stickyHeaderRef}>
        <nav>
          <ul>
            <li className={activeSection === 'eventos' ? 'active' : ''}>
              <button onClick={() => scrollToSection('eventos')}>Eventos</button>
            </li>
            <li className={activeSection === 'amenidades' ? 'active' : ''}>
              <button onClick={() => scrollToSection('amenidades')}>Amenidades</button>
            </li>
            <li className={activeSection === 'paquetes' ? 'active' : ''}>
              <button onClick={() => scrollToSection('paquetes')}>Paquetes</button>
            </li>
            <li className={activeSection === 'menu' ? 'active' : ''}>
              <button onClick={() => scrollToSection('menu')}>Menú</button>
            </li>
            <li className={activeSection === 'adicionales' ? 'active' : ''}>
              <button onClick={() => scrollToSection('adicionales')}>Servicios adicionales</button>
            </li>
          </ul>
        </nav>
      </header>

      <div className="main-container">
        <div className="left-column">
          <div>
            <Confirmacion
              id={id}
              phoneNumber={phone}
              eventos={eventos}
              capacityInitial={capacityInitial}
              capacityMax={capacityMax}
              nombrePaquetes={nombrePaquetes}
            />
          </div>

          <div id="eventos" className="filtered-item-list">
            <FilteredItemList type="Eventos celebrados" items={eventos} columns={3} initialVisibleCount={6} />
          </div>

          <div id="amenidades" className="filtered-item-list">
            <FilteredItemList type="amenidades" items={amenidades} />
          </div>
        </div>

        <div className="right-column">
          <div> 
            <MapComponent lat={lat} lng={long} />
            <p className="address">
              {itemDetails.address}
            </p>
          </div>  

          {/* 🔹 Div para mostrar promociones */}
          <div className="promotions-container">
              {/* <div className="icon-row">
                <FaGlassCheers className="icon icon-orange" />
                <FaBirthdayCake className="icon icon-yellow" />
                <GiPartyPopper className="icon icon-gold" />
              </div> */}

              <h1 className="promotions-title">Promociones</h1>

              <div className="icon-row">
                <GiTicket className="icon icon-blue" />
                <GiBalloons className="icon icon-green" />
                <MdCelebration className="icon icon-purple" />
              </div>
           
              <ul>
                {itemDetails.promociones && itemDetails.promociones.length > 0 ? (
                  itemDetails.promociones.map((promo, index) => (
                    <li key={index}  className="promo-icon"><span><FaFire className="icon-red"/> </span> {promo}</li>
                  ))
                ) : (
                  <p>No hay promociones disponibles.</p>
                )}
              </ul>
          </div>

          <VideoComponent  videos={video}/>




        </div>
      </div>

      <div id="paquetes" className="promotion">
        <h3>Explora nuestros paquetes y descubre cómo podemos hacer que tu evento sea perfecto.</h3>
        <h2 className="promociones-title">Paquetes</h2>
     
        {/* Verificamos si hay algún paquete con datos disponibles */}
        {paquetes.some((paquete) => 
          paquete.nombre && paquete.descripcion
        ) ? (
          paquetes
            .slice() // Clonamos el array para no modificar el original
            .sort((a, b) => a.nombre.localeCompare(b.nombre)) // Ordenamos alfabéticamente por `nombre`
            .map((paquete) => (
              <PromotionSections
                key={paquete.id}
                basicData={[paquete]} // Pasar siempre un array     
              />
            ))
        ) : (
          <p className="alert">No hay información disponible sobre los paquetes.</p>
        )}
      </div>


      <div id="menu" className="menu-list">


      <h2 className="menu-title along-menu">
      {TipoPaquete[0] === "sin paquete" ? 'Costos por servicio' : 'Menú'}</h2>
  
        {/* Verificamos si hay al menos un paquete con datos de comidas, bebidas o complementos */}
        {paquetes.some((paquete) => 
            paquete.comidas?.length > 0 
          ) ? (
            paquetes
              .slice() // Clonamos el array para no modificar el original
              .sort((a, b) => a.nombre.localeCompare(b.nombre)) // Ordenamos alfabéticamente por `nombre`
              .map((paquete) => (
                <MenuWithSections
                  key={paquete.id}
                  comidas={paquete.comidas}
                  paquete={TipoPaquete[0]}
                />
              ))
          ) : (
            <p className="alert">No hay información disponible sobre el menú.</p>
          )}
      </div>

      
      <div id="adicionales">
        <FilteredItemList type="Servicios adicionales" items={adicionales} columns={4} initialVisibleCount={8} />
      </div>
    </div>
  );
};

